<template>
  <ion-page>
    <ion-content :fullscreen="true">
      <div class="row">
        <HeaderComp currentPage="chapter"></HeaderComp>

        <LesothoChapterContent class="text-black" />

        <FooterComp></FooterComp>
      </div>
    </ion-content>
  </ion-page>
</template>
<script>
import HeaderComp from '@/components/layouts/HeaderComp'
import FooterComp from '@/components/layouts/FooterComp'
import LesothoChapterContent from '@/views/content/chapters/LesothoChapterContent'
export default {
  components: { LesothoChapterContent, FooterComp, HeaderComp },

  data() {
    return {}
  },
}
</script>
